<div class="user-exam-list-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="page-title">
            <i class="bi bi-clipboard-check-fill me-2"></i>
            รายการสอบของฉัน
          </h1>
          <p class="page-subtitle">ตรวจสอบรายการสอบและผลการสอบที่คุณลงทะเบียนไว้</p>
        </div>
        <button class="btn btn-outline-light" (click)="goBack()">
          <i class="bi bi-arrow-left me-2"></i>
          กลับหน้าหลัก
        </button>
      </div>
    </div>
  </div>

  <!-- Statistics Section -->
  <div class="statistics-section" *ngIf="!error && examRegistrations.length > 0">
    <div class="container">
      <div class="row g-3">
        <div class="col-md-4 col-sm-6">
          <div class="stat-card stat-primary">
            <div class="stat-icon">
              <i class="bi bi-clipboard-data"></i>
            </div>
            <div class="stat-content">
              <h3>{{ totalExams }}</h3>
              <p>รายการสอบทั้งหมด</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="stat-card stat-success">
            <div class="stat-icon">
              <i class="bi bi-calendar-event"></i>
            </div>
            <div class="stat-content">
              <h3>{{ passedExams }}</h3>
              <p>ผ่านการทดสอบ</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="stat-card stat-info">
            <div class="stat-icon">
              <i class="bi bi-hourglass-split"></i>
            </div>
            <div class="stat-content">
              <h3>{{ pendingResultExams }}</h3>
              <p>รอประกาศผล</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <div class="container">
      <!-- Error State -->
      <div *ngIf="error" class="alert alert-danger d-flex align-items-center" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-3" style="font-size: 1.5rem;"></i>
        <div class="flex-grow-1">
          <strong>เกิดข้อผิดพลาด</strong>
          <p class="mb-0">{{ error }}</p>
        </div>
        <button class="btn btn-outline-danger ms-3" (click)="retry()">
          <i class="bi bi-arrow-clockwise me-2"></i>
          ลองใหม่
        </button>
      </div>

      <!-- Exam List -->
      <div *ngIf="!error" class="exam-list">
        <!-- Empty State -->
        <div *ngIf="examRegistrations.length === 0" class="empty-state">
          <i class="bi bi-inbox"></i>
          <h3>ยังไม่มีรายการสอบ</h3>
          <p>คุณยังไม่ได้ลงทะเบียนสอบใดๆ</p>
          <button class="btn btn-primary" (click)="goBack()">
            <i class="bi bi-arrow-left me-2"></i>
            กลับหน้าหลัก
          </button>
        </div>

        <!-- Exam Cards -->
        <div *ngIf="examRegistrations.length > 0" class="row g-4">
          <div class="col-12" *ngFor="let registration of examRegistrations; let i = index">
            <div class="exam-card" [class.upcoming]="isExamUpcoming(registration.exam.examDate)">
              <div class="exam-card-header">
                <div class="exam-thumbnail">
                  <div class="thumbnail-placeholder">
                    <i class="bi bi-clipboard-check"></i>
                  </div>
                </div>
                <div class="exam-info flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h4 class="exam-title">{{ registration.exam.examTitle }}</h4>
                    <!-- แสดงผลการสอบเฉพาะกรณี "สอบผ่าน" เท่านั้น
                         (ยังไม่ประกาศผล/ไม่ผ่าน จะไม่แสดงอะไร) -->
                    <span class="status-badge passed" *ngIf="isExamPassed(registration)">
                      <i class="bi bi-check-circle"></i>
                      สอบผ่าน
                    </span>
                  </div>
                </div>
              </div>

              <div class="exam-card-body">

                <div class="row g-3">
                  <div class="col-md-4 col-sm-6">
                    <div class="info-box">
                      <label>ระดับผู้ประเมิน</label>
                      <span class="badge" [ngClass]="getValuerRankBadgeClass(registration.exam.valuerRank)">
                        {{ registration.exam.valuerRank }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6">
                    <div class="info-box">
                      <label>ค่าสอบ</label>
                      <span class="value">฿{{ formatPrice(registration.exam.examFee) }}</span>
                    </div>
                  </div>
                </div>


                <!-- Status Information Row -->
                <div class="row g-3 mt-2">
                  <div class="col-md-4 col-sm-6">
                    <div class="info-box">
                      <label>วันที่ลงทะเบียน</label>
                      <span class="value">{{ formatDate(registration.enrolledAt) }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6" *ngIf="registration.examListStatus">
                    <div class="info-box">
                      <label>สถานะการลงทะเบียน</label>
                      <span class="badge" [ngClass]="getRegistrationStatusBadgeClass(registration.examListStatus.name)">
                        {{ registration.examListStatus.name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6" *ngIf="registration.examListPaymentStatus">
                    <div class="info-box">
                      <label>สถานะการชำระเงิน</label>
                      <span class="badge"
                        [ngClass]="getPaymentStatusBadgeClass(registration.examListPaymentStatus.name)">
                        {{ registration.examListPaymentStatus.name }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row g-3 mt-2">
                  <div class="col-md-4">
                    <div class="info-box">
                      <label>วันที่สอบ</label>
                      <span class="value">{{ formatDate(registration.exam.examDate) }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="info-box">
                      <label>เวลาสอบ</label>
                      <span class="value">{{ registration.exam.examTime }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="info-box">
                      <label>สถานที่สอบ</label>
                      <span class="value">{{ registration.exam.examLocation }}</span>
                    </div>
                  </div>
                </div>

                <!-- Receipt Type Selection Section (Before Payment Slip Upload) -->
                <div class="receipt-type-selection-section mt-3 mb-3">
                  <label class="section-label">
                    <i class="bi bi-file-earmark-text me-2"></i>
                    {{ isReceiptTypeReadOnly(registration.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}
                  </label>

                  <!-- Read-only view when receipt type is already set -->
                  <div *ngIf="isReceiptTypeReadOnly(registration.id)" class="receipt-type-readonly">
                    <div class="selected-receipt-type">
                      <i class="bi" [class.bi-person-circle]="getReceiptType(registration.id) === 'individual'"
                        [class.bi-building]="getReceiptType(registration.id) === 'company'"></i>
                      <span>{{ getReceiptTypeLabel(getReceiptType(registration.id)) }}</span>
                      <span class="badge bg-success ms-2">
                        <i class="bi bi-check-circle me-1"></i>
                        บันทึกแล้ว
                      </span>
                    </div>
                    <small class="text-muted d-block mt-2">
                      <i class="bi bi-info-circle me-1"></i>
                      ประเภทใบเสร็จถูกบันทึกแล้ว ไม่สามารถแก้ไขได้
                    </small>
                  </div>

                  <!-- Editable radio buttons when receipt type is not set -->
                  <div *ngIf="!isReceiptTypeReadOnly(registration.id)" class="radio-group">
                    <div class="radio-option">
                      <input type="radio" [id]="'individual-' + registration.id"
                        [name]="'receiptType-' + registration.id" value="individual"
                        [checked]="getReceiptType(registration.id) === 'individual'"
                        (change)="onReceiptTypeChange(registration.id, 'individual')">
                      <label [for]="'individual-' + registration.id" class="radio-label">
                        <i class="bi bi-person-circle me-1"></i>
                        ออกใบเสร็จแบบบุคคลธรรมดา
                      </label>
                    </div>
                    <div class="radio-option">
                      <input type="radio" [id]="'company-' + registration.id" [name]="'receiptType-' + registration.id"
                        value="company" [checked]="getReceiptType(registration.id) === 'company'"
                        (change)="onReceiptTypeChange(registration.id, 'company')">
                      <label [for]="'company-' + registration.id" class="radio-label">
                        <i class="bi bi-building me-1"></i>
                        ออกใบเสร็จแบบนิติบุคคล
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Payment Slip Upload Section -->
                <div class="payment-slip-upload mt-3">
                  <label class="upload-label">
                    <i class="bi bi-receipt me-2"></i>
                    กรุณาอัปโหลดสลิปการชำระเงินเพื่อยืนยันการชำระเงิน
                  </label>

                  <!-- Transfer Date-Time Section -->
                  <div class="transfer-datetime-section mt-3 mb-3">
                    <label class="datetime-label">
                      <i class="bi bi-clock-history me-2"></i>
                      แจ้งวันที่และเวลาการโอนเงิน
                      <span class="text-danger">*</span>
                    </label>
                    <div class="datetime-input-wrapper">
                      <input type="datetime-local" [id]="'transferDateTime-' + registration.id"
                        class="form-control datetime-input" (change)="onTransferDateTimeChange(registration.id, $event)"
                        [max]="currentYear + '-12-31T23:59'" required>
                      <small class="text-muted d-block mt-2">
                        <i class="bi bi-info-circle me-1"></i>
                        กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                      </small>
                      <!-- Display formatted date-time if selected -->
                      <div class="selected-datetime-display" *ngIf="getTransferDateTime(registration.id)">
                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                        <span class="datetime-text">{{ getTransferDateTime(registration.id) }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Bank Account Information -->
                  <div class="bank-info-box mt-3 mb-3">
                    <div class="bank-info-header">
                      <i class="bi bi-bank2 me-2"></i>
                      <strong>ข้อมูลบัญชีสำหรับโอนเงิน</strong>
                    </div>
                    <div class="bank-info-content">
                      <div class="bank-detail-row">
                        <span class="detail-label">ชื่อบัญชี:</span>
                        <span class="detail-value">บัญชีเพื่อการจัดสอบผู้ประเมินหลัก
                          สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</span>
                      </div>
                      <div class="bank-detail-row">
                        <span class="detail-label">ธนาคาร:</span>
                        <span class="detail-value">ธนาคารกรุงเทพ ประเภทออมทรัพย์</span>
                      </div>
                      <div class="bank-detail-row">
                        <span class="detail-label">เลขที่บัญชี:</span>
                        <span class="detail-value account-number">137-4-01388-4</span>
                      </div>
                    </div>
                  </div>

                  <!-- Image Preview Section -->
                  <div class="image-preview-container"
                    *ngIf="getPaymentSlipPreview(registration.id) || registration.paymentSlip">
                    <div class="preview-header">
                      <span class="preview-title">
                        <i class="bi bi-image me-2"></i>
                        {{ registration.paymentSlip && !getPaymentSlipPreview(registration.id) ? 'สลิปที่อัปโหลดแล้ว' :
                        'ตัวอย่างสลิป' }}
                      </span>
                      <button class="btn-remove-preview" *ngIf="getPaymentSlipPreview(registration.id)"
                        (click)="removePaymentSlipPreview(registration.id)" type="button">
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </div>
                    <div class="preview-image-wrapper">
                      <img [src]="getPaymentSlipPreview(registration.id) || registration.paymentSlip"
                        alt="Payment Slip Preview" class="preview-image"
                        (click)="openImageModal((getPaymentSlipPreview(registration.id) || registration.paymentSlip) || '')">
                      <div class="preview-overlay"
                        (click)="openImageModal((getPaymentSlipPreview(registration.id) || registration.paymentSlip) || '')">
                        <i class="bi bi-zoom-in"></i>
                        <span>คลิกเพื่อดูขนาดเต็ม</span>
                      </div>
                    </div>
                  </div>

                  <div class="upload-zone">
                    <input type="file" [id]="'paymentSlip-' + i" class="file-input"
                      accept="image/jpeg,image/jpg,image/png" (change)="onPaymentSlipSelected($event, registration.id)"
                      #fileInput>
                    <label [for]="'paymentSlip-' + i" class="file-label">
                      <i class="bi bi-cloud-upload"></i>
                      <span>{{ registration.paymentSlip && !getPaymentSlipPreview(registration.id) ? 'เปลี่ยนสลิป' :
                        'Choose File' }}</span>
                      <span class="file-name" *ngIf="getSelectedFileName(registration.id)">{{
                        getSelectedFileName(registration.id) }}</span>
                    </label>
                    <small class="text-muted d-block mt-2">
                      รองรับไฟล์ JPG, JPEG เท่านั้น (ขนาดไม่เกิน 5MB)
                    </small>
                    <button class="btn btn-submit-slip mt-3"
                      [disabled]="!getSelectedFileName(registration.id) || isUploadingSlip(registration.id)"
                      (click)="submitPaymentSlip(registration.id)">
                      <i class="bi bi-send-fill me-2"></i>
                      {{ isUploadingSlip(registration.id) ? 'กำลังส่ง...' : 'ส่งสลิปการชำระเงิน' }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="exam-card-footer">
                <div class="footer-info">
                  <small class="text-muted">
                    <i class="bi bi-calendar-plus me-1"></i>
                    ลงทะเบียนเมื่อ: {{ formatDate(registration.enrolledAt) }}
                  </small>

                  <!-- Download Receipt Button (Only shown when payment is completed) -->
                  <div *ngIf="registration.examListPaymentStatusId === 3" class="receipt-download-section">
                    <div class="footer-buttons">
                      <button class="btn btn-download-slip" [disabled]="!getReceiptType(registration.id)"
                        (click)="downloadReceipt(registration.id)" title="ดาวน์โหลดใบเสร็จ/สลิปการชำระเงิน">
                        <i class="bi bi-receipt me-2"></i>
                        ดาวน์โหลดใบเสร็จ/สลิปการชำระเงิน
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Modal -->
  <div class="image-modal" *ngIf="imageModalUrl" (click)="closeImageModal()">
    <div class="modal-backdrop"></div>
    <div class="modal-content-wrapper">
      <button class="btn-close-modal" (click)="closeImageModal()">
        <i class="bi bi-x-lg"></i>
      </button>
      <img [src]="imageModalUrl" alt="Payment Slip Full Size" class="modal-image">
    </div>
  </div>
</div>